export const specialtyTypes = {
    GET_All_SPECIALITIES_LIST: "GET_All_SPECIALITIES_LIST",
    GET_SPECIALITIES_LIST: "GET_SPECIALITIES_LIST",
    GET_SPECIALTY_DETAILS: "GET_SPECIALTY_DETAILS",
    CURRENT_SPECIALTY_NOT_FOUND: "CURRENT_SPECIALTY_NOT_FOUND",
    CLEAR_SPECIALTY_LIST: "CLEAR_SPECIALTY_LIST",
    CLEAR_SPECIALTY_DETAILS: "CLEAR_SPECIALTY_DETAILS",
};